import { fToNow } from '@aibees/shared/utils';
import { useMemo } from 'react';
import { useBootstrapApi } from './bootstrap/use-bootstrap-api';

export function useRecordLastUpdate() {
  const { data } = useBootstrapApi();
  const lastUpdatePeopleDate = data?.person?.lastUpdate;
  const lastUpdateCompanyDate = data?.company?.lastUpdate;

  const lastUpdatePeople = useMemo(() => {
    return fToNow(lastUpdatePeopleDate, { unit: 'day' });
  }, [lastUpdatePeopleDate]);

  const lastUpdateCompany = useMemo(() => {
    return fToNow(lastUpdateCompanyDate, { unit: 'day' });
  }, [lastUpdateCompanyDate]);

  return {
    lastUpdatePeople,
    lastUpdateCompany,
  };
}
